import { MainLayout } from "@components/layouts/MainLayout";
import { Activity } from "lucide-react";
import { PageHeader } from "@components/layouts/PageHeader";
import { TopPlayers } from "@components/players/activity-engagement/TopPlayers";
import { ClubPerformance } from "@components/players/activity-engagement/ClubPerformance";
import { PlayTime } from "@components/players/activity-engagement/PlayTime";
import { useState } from "react";
import { useApiDataWithDateRange } from "@hooks/useApiDataWithDateRange";
import { addDays } from "date-fns";
import type { DateRange } from "react-day-picker";
import { DatePickerWithRange } from "@components/ui/date-range-picker";
import { Separator } from "@components/ui/separator";

export default function ActivityEngagement() {
  const [dateRange, setDateRange] = useState<DateRange | undefined>({
    from: addDays(new Date(), -7),
    to: new Date(),
  });

  const [activityStats, loading, error] = useApiDataWithDateRange(
    "/api/superone/activity-stats-7-days-with-club",
    dateRange,
    {
      transform: (res: any) => {
        if (Array.isArray(res)) return res;
        if (res && typeof res === "object") {
          if (Array.isArray(res.activityStats)) return res.activityStats;
          if (Array.isArray(res.players)) return res.players;
        }
        return [];
      },
    }
  );

  return (
    <MainLayout>
      <div className="space-y-6 p-6">
        <div className="flex flex-col md:flex-row md:items-center md:justify-between mb-2">
          <PageHeader
            icon={<Activity className="h-6 w-6 text-blue-600" />}
            title="Activity & Engagement"
            subtitle="Player activity and engagement metrics."
          />
          <div className="mt-4 md:mt-0">
            <DatePickerWithRange
              defaultRange={dateRange}
              onDateChange={setDateRange}
            />
          </div>
        </div>
        <Separator className="mb-12" />
        <div className="space-y-8">
          <div className="pt-4 pb-4">
            <TopPlayers
              data={activityStats}
              loading={loading}
              error={error}
              startDate={dateRange?.from}
              endDate={dateRange?.to}
            />
          </div>
          <div className="pt-4 pb-4">
            <ClubPerformance
              data={activityStats}
              loading={loading}
              error={error}
              startDate={dateRange?.from}
              endDate={dateRange?.to}
            />
          </div>
          {/* <div className="pt-4 pb-4">
            <PlayTime data={activityStats} loading={loading} error={error} />
          </div> */}
        </div>
      </div>
    </MainLayout>
  );
}
